export const SECTION_IDS = ["inv-step-1", "inv-step-2", "inv-step-3", "inv-step-4"] as const;

const REQUIRED_FIELDS: readonly (readonly string[])[] = [
  ["receiverBusinessId", "receiverBranchId", "paymentDate"],
  ["senderBranchId", "senderAccId"],
  ["lines"],
  ["attachments"],
];

export function computeStepCompletions(values: Record<string, any> | undefined | null): boolean[] {
  if (!values) return REQUIRED_FIELDS.map(() => false);
  return REQUIRED_FIELDS.map((fields) =>
    fields.every((f) => {
      const v = values[f];
      if (Array.isArray(v)) return v.length > 0;
      return v !== undefined && v !== null && v !== "";
    }),
  );
}

export const STEP_PRIMARY = "var(--mantine-color-brand-6)";
export const STEP_PRIMARY_BG = "color-mix(in srgb, var(--mantine-color-brand-6) 10%, transparent)";
